import React from 'react';
import { FormattedMessage } from 'react-intl';

import { EcpStoreType } from '../../../../../../rest/ecp-locator';
import {
  ShopTypeFilters,
  SpecializationTypeFilters,
} from '../../../../../../models';
import { ToggleButtonOptions } from '../../../../../common/toggle-button-group';

export const serviceTypeFilteringItems: ToggleButtonOptions[] = [{
  children: (
    <FormattedMessage
      id="ecp.filters.modal.serviceType.items.pickUpLenses.label"
    />
  ),
  value: EcpStoreType.fitter,
}, {
  children: (
    <FormattedMessage
      id="ecp.filters.modal.serviceType.items.buyLenses.label"
    />
  ),
  value: EcpStoreType.retailer,
}];

export const specializationTypeFilteringItems: ToggleButtonOptions[] = [{
  children: (
    <FormattedMessage
      id="ecp.filters.modal.specializationType.items.astigmatism"
    />
  ),
  value: SpecializationTypeFilters.astigmatism,
  testId: 'ecp-astigmatism',
  tooltip: <FormattedMessage id="ecp.spec.additional.astigmatism.tooltip" />,
}, {
  children: <FormattedMessage id="ecp.spec.additional.presbyopia" />,
  value: SpecializationTypeFilters.presbyopia,
  testId: 'ecp-presbyopia',
  tooltip: <FormattedMessage id="ecp.spec.additional.presbyopia.tooltip" />,
}];

export const specFilterItemsWithMyopia: ToggleButtonOptions[] = [
  ...specializationTypeFilteringItems,
  {
    children: (
      <FormattedMessage id="ecp.spec.additional.myopia_control" />
    ),
    value: SpecializationTypeFilters.myopiaControl,
    testId: 'ecp-myopia-control',
  },
];

export const shopTypeFilteringItems: ToggleButtonOptions[] = [{
  children: (
    <FormattedMessage
      id="ecp.filters.modal.shopType.items.optics"
    />
  ),
  value: ShopTypeFilters.optics,
}, {
  children: (
    <FormattedMessage
      id="ecp.filters.modal.shopType.items.clinics"
    />
  ),
  value: ShopTypeFilters.clinics,
}, {
  children: (
    <FormattedMessage
      id="ecp.filters.modal.shopType.items.vendings"
    />
  ),
  value: ShopTypeFilters.vendings,
}];
